/**
 * Funkcinės Terapijos Centras — Ar man reikia operacijos?
 * Self-injecting widget. Embed with:
 *
 *   Place <div id="ftc-surgery-checker"></div> in your blog post HTML.
 *   Load via Liquid: {{ 'ftc-surgery.js' | asset_url | script_tag }}
 */
(function () {
  'use strict';

  var scriptTag = document.currentScript;
  var KLAVIYO_COMPANY_ID = scriptTag.getAttribute('data-klaviyo-id') || 'WGyTS6';
  var KLAVIYO_LIST_ID = scriptTag.getAttribute('data-list-id') || 'TEnbve';
  var BOOKING_URL = scriptTag.getAttribute('data-booking-url') || 'https://funkcinesterapijoscentras.lt/pages/registracija';

  // ── Inject CSS ──
  var css = document.createElement('style');
  css.textContent = '' +
    '.ftcs *,.ftcs *::before,.ftcs *::after{box-sizing:border-box;margin:0;padding:0}' +
    '.ftcs{font-family:"Segoe UI",system-ui,-apple-system,sans-serif;max-width:640px;margin:40px auto;border-radius:16px;overflow:hidden;box-shadow:0 8px 32px rgba(30,126,186,.18);background:#fff}' +
    '.ftcs-header{background:linear-gradient(135deg,#1E7EBA 0%,#1a6da3 100%);padding:32px 28px 24px;text-align:center;position:relative;overflow:hidden}' +
    '.ftcs-header::before{content:"";position:absolute;top:-40%;right:-20%;width:260px;height:260px;background:rgba(0,190,195,.12);border-radius:50%}' +
    '.ftcs-header::after{content:"";position:absolute;bottom:-30%;left:-10%;width:180px;height:180px;background:rgba(255,255,255,.06);border-radius:50%}' +
    '.ftcs-header h2{color:#fff;font-size:22px;font-weight:700;margin-bottom:6px;position:relative;z-index:1;line-height:1.3}' +
    '.ftcs-header p{color:rgba(255,255,255,.85);font-size:14px;position:relative;z-index:1}' +
    '.ftcs-badge{display:inline-block;background:rgba(0,190,195,.25);color:#fff;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:1.2px;padding:4px 14px;border-radius:20px;margin-bottom:12px;position:relative;z-index:1}' +
    '.ftcs-progress-wrap{padding:0 28px;margin-top:-8px;position:relative;z-index:2}' +
    '.ftcs-progress-bar{height:6px;background:#e8f0f5;border-radius:3px;overflow:hidden;margin-top:16px}' +
    '.ftcs-progress-fill{height:100%;background:linear-gradient(90deg,#00BEC3,#1E7EBA);border-radius:3px;transition:width .5s cubic-bezier(.4,0,.2,1);width:0%}' +
    '.ftcs-step-count{text-align:center;font-size:12px;color:#7a9bb5;margin-top:8px;font-weight:500}' +
    '.ftcs-body{padding:24px 28px 28px;min-height:320px;position:relative}' +
    '.ftcs-intro{text-align:center}' +
    '.ftcs-intro-icon{width:72px;height:72px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 20px}' +
    '.ftcs-intro-icon svg{width:36px;height:36px;color:#1E7EBA}' +
    '.ftcs-intro h3{font-size:18px;color:#1a2e3d;margin-bottom:10px;font-weight:600}' +
    '.ftcs-intro p{font-size:14px;color:#5a7080;line-height:1.6;margin-bottom:8px}' +
    '.ftcs-intro-list{text-align:left;margin:16px auto;max-width:380px}' +
    '.ftcs-intro-list-item{display:flex;align-items:flex-start;gap:10px;padding:8px 0;font-size:13px;color:#3d5a6e}' +
    '.ftcs-intro-list-item .ftcs-check{width:20px;height:20px;min-width:20px;background:#00BEC3;border-radius:50%;display:flex;align-items:center;justify-content:center;margin-top:1px}' +
    '.ftcs-intro-list-item .ftcs-check svg{width:12px;height:12px;color:#fff}' +
    '.ftcs-slide{display:none;animation:ftcsFadeIn .4s ease}' +
    '.ftcs-slide.active{display:block}' +
    '@keyframes ftcsFadeIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}' +
    '.ftcs-question-num{font-size:12px;font-weight:600;color:#00BEC3;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px}' +
    '.ftcs-question-text{font-size:17px;color:#1a2e3d;font-weight:600;margin-bottom:6px;line-height:1.4}' +
    '.ftcs-question-hint{font-size:13px;color:#7a9bb5;margin-bottom:24px;line-height:1.5}' +
    '.ftcs-slider-wrap{padding:12px 0 8px}' +
    '.ftcs-slider-labels{display:flex;justify-content:space-between;margin-bottom:12px}' +
    '.ftcs-slider-label{font-size:12px;font-weight:500;padding:6px 12px;border-radius:8px;transition:all .3s ease;max-width:45%;text-align:center;line-height:1.3}' +
    '.ftcs-slider-label.left{color:#27ae60;background:#e8f8ef}' +
    '.ftcs-slider-label.right{color:#c0392b;background:#fce8e6}' +
    '.ftcs-range-track{position:relative;height:48px;display:flex;align-items:center}' +
    '.ftcs-range{-webkit-appearance:none;appearance:none;width:100%;height:8px;border-radius:4px;background:linear-gradient(90deg,#27ae60,#e0e8ed 50%,#e05555);outline:none;cursor:pointer}' +
    '.ftcs-range::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:28px;height:28px;border-radius:50%;background:#fff;border:3px solid #00BEC3;box-shadow:0 2px 8px rgba(0,190,195,.3);cursor:pointer;transition:transform .2s ease,box-shadow .2s ease}' +
    '.ftcs-range::-webkit-slider-thumb:hover{transform:scale(1.15);box-shadow:0 3px 14px rgba(0,190,195,.4)}' +
    '.ftcs-range::-moz-range-thumb{width:28px;height:28px;border-radius:50%;background:#fff;border:3px solid #00BEC3;box-shadow:0 2px 8px rgba(0,190,195,.3);cursor:pointer}' +
    '.ftcs-range-value{text-align:center;margin-top:8px;font-size:13px;font-weight:600;color:#1E7EBA;min-height:20px}' +
    '.ftcs-options{display:flex;flex-direction:column;gap:10px;margin-top:4px}' +
    '.ftcs-option{display:flex;align-items:center;gap:12px;padding:14px 16px;border:2px solid #e8f0f5;border-radius:12px;cursor:pointer;transition:all .25s ease;background:#fff}' +
    '.ftcs-option:hover{border-color:#b8dce8;background:#f6fbfd}' +
    '.ftcs-option.selected{border-color:#00BEC3;background:#e6f9fa}' +
    '.ftcs-option-radio{width:22px;height:22px;min-width:22px;border-radius:50%;border:2px solid #c8d8e2;display:flex;align-items:center;justify-content:center;transition:all .25s ease}' +
    '.ftcs-option.selected .ftcs-option-radio{border-color:#00BEC3;background:#00BEC3}' +
    '.ftcs-option.selected .ftcs-option-radio::after{content:"";width:8px;height:8px;background:#fff;border-radius:50%}' +
    '.ftcs-option-text{font-size:14px;color:#2a4050;font-weight:500}' +
    '.ftcs-buttons{display:flex;justify-content:space-between;align-items:center;margin-top:28px;gap:12px}' +
    '.ftcs-btn{padding:12px 28px;border-radius:10px;font-size:14px;font-weight:600;cursor:pointer;border:none;transition:all .3s ease;display:inline-flex;align-items:center;gap:6px}' +
    '.ftcs-btn-primary{background:linear-gradient(135deg,#00BEC3,#00a8ad);color:#fff;box-shadow:0 4px 14px rgba(0,190,195,.3)}' +
    '.ftcs-btn-primary:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,190,195,.4)}' +
    '.ftcs-btn-secondary{background:transparent;color:#7a9bb5;border:2px solid #e0e8ed}' +
    '.ftcs-btn-secondary:hover{border-color:#b8d0dd;color:#5a7a90}' +
    '.ftcs-btn-large{width:100%;justify-content:center;padding:14px 28px;font-size:15px}' +
    '.ftcs-btn svg{width:16px;height:16px}' +
    '.ftcs-email-gate{text-align:center}' +
    '.ftcs-email-gate h3{font-size:18px;color:#1a2e3d;margin-bottom:8px;font-weight:600}' +
    '.ftcs-email-gate p{font-size:14px;color:#5a7080;margin-bottom:20px;line-height:1.5}' +
    '.ftcs-email-icon{width:64px;height:64px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 16px}' +
    '.ftcs-email-icon svg{width:30px;height:30px;color:#1E7EBA}' +
    '.ftcs-input-wrap{position:relative;margin-bottom:12px}' +
    '.ftcs-input{width:100%;padding:14px 16px;border:2px solid #e0e8ed;border-radius:10px;font-size:14px;font-family:inherit;color:#2a4050;outline:none;transition:border-color .3s ease;background:#fff}' +
    '.ftcs-input:focus{border-color:#00BEC3}' +
    '.ftcs-input::placeholder{color:#a8bcc8}' +
    '.ftcs-email-note{font-size:11px;color:#a0b0bb;margin-top:8px}' +
    '.ftcs-email-error{color:#e05555;font-size:12px;margin-top:4px;display:none}' +
    '.ftcs-results{text-align:center}' +
    '.ftcs-result-circle-wrap{position:relative;width:160px;height:160px;margin:0 auto 20px}' +
    '.ftcs-result-circle{width:160px;height:160px;border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;z-index:1}' +
    '.ftcs-result-circle.conservative{background:linear-gradient(135deg,#e8f8ef,#d0f0db);border:3px solid #27ae60}' +
    '.ftcs-result-circle.specialist{background:linear-gradient(135deg,#fff4e6,#ffe8cc);border:3px solid #e8a04c}' +
    '.ftcs-result-circle.urgent{background:linear-gradient(135deg,#fce8e6,#f8d0cc);border:3px solid #e05555}' +
    '.ftcs-result-type{font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:1px;margin-bottom:2px}' +
    '.ftcs-result-label{font-size:18px;font-weight:700;text-align:center;line-height:1.2;padding:0 8px}' +
    '.ftcs-result-circle.conservative .ftcs-result-type{color:#1e8449}.ftcs-result-circle.conservative .ftcs-result-label{color:#1a7a40}' +
    '.ftcs-result-circle.specialist .ftcs-result-type{color:#c46b20}.ftcs-result-circle.specialist .ftcs-result-label{color:#a35a18}' +
    '.ftcs-result-circle.urgent .ftcs-result-type{color:#c0392b}.ftcs-result-circle.urgent .ftcs-result-label{color:#a93226}' +
    '.ftcs-result-text{font-size:15px;color:#2a4050;line-height:1.6;margin-bottom:16px;max-width:480px;margin-left:auto;margin-right:auto}' +
    '.ftcs-result-detail{background:#f6f9fb;border-radius:12px;padding:16px 20px;margin-bottom:20px;text-align:left}' +
    '.ftcs-result-detail h4{font-size:14px;font-weight:600;color:#1a2e3d;margin-bottom:8px}' +
    '.ftcs-result-detail p{font-size:13px;color:#5a7080;line-height:1.5}' +
    '.ftcs-result-cta,.ftcs-result-cta:visited,.ftcs-result-cta:active,.ftcs-result-cta:hover{background:#00BEC3;color:#fff !important;padding:14px 32px;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;border:none;display:inline-flex;align-items:center;gap:8px;transition:all .3s ease;box-shadow:0 4px 14px rgba(0,190,195,.3);text-decoration:none !important}' +
    '.ftcs-result-cta:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,190,195,.4)}' +
    '.ftcs-result-cta svg{width:18px;height:18px}' +
    '.ftcs-disclaimer{font-size:11px;color:#a0b0bb;margin-top:16px;line-height:1.4;padding-top:12px;border-top:1px solid #eef2f5}' +
    '@media(max-width:480px){.ftcs{margin:16px 8px;border-radius:12px}.ftcs-header{padding:24px 20px 18px}.ftcs-header h2{font-size:19px}.ftcs-body{padding:20px 20px 24px}.ftcs-progress-wrap{padding:0 20px}.ftcs-slider-label{font-size:11px;padding:4px 8px}.ftcs-buttons{flex-direction:column-reverse}.ftcs-btn{width:100%;justify-content:center}}';
  document.head.appendChild(css);

  // ── SVG helpers ──
  var svgArrowRight = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6"/></svg>';
  var svgArrowLeft  = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M11 17l-5-5m0 0l5-5m-5 5h12"/></svg>';
  var svgCheck      = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4"/></svg>';
  var svgCheckSmall = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>';
  var svgSpine      = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 2v4m0 4v4m0 4v4M8 4h8M9 8h6M8 12h8M9 16h6M8 20h8"/></svg>';
  var svgMail       = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>';
  var svgCalendar   = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>';

  // ── Build HTML ──
  var html = '' +
    '<div class="ftcs-header">' +
      '<div class="ftcs-badge">Nemokamas testas</div>' +
      '<h2>Ar man reikia operacijos?</h2>' +
      '<p>5 žingsnių sprendimų pagalbininkas</p>' +
    '</div>' +
    '<div class="ftcs-progress-wrap" id="ftcsProgressWrap" style="display:none;">' +
      '<div class="ftcs-progress-bar"><div class="ftcs-progress-fill" id="ftcsProgressFill"></div></div>' +
      '<div class="ftcs-step-count" id="ftcsStepCount"></div>' +
    '</div>' +
    '<div class="ftcs-body">' +

      // Intro
      '<div class="ftcs-slide active" id="ftcsIntro"><div class="ftcs-intro">' +
        '<div class="ftcs-intro-icon">' + svgSpine + '</div>' +
        '<h3>Sužinokite, ar jums reikalinga operacija</h3>' +
        '<p>Atsakykite į 5 klausimus ir sužinokite, ar jūsų stuburo problema gali būti išspręsta konservatyviai, ar verta kreiptis dėl operacijos.</p>' +
        '<div class="ftcs-intro-list">' +
          '<div class="ftcs-intro-list-item"><div class="ftcs-check">' + svgCheckSmall + '</div><span>Užtrunka tik 2 minutes</span></div>' +
          '<div class="ftcs-intro-list-item"><div class="ftcs-check">' + svgCheckSmall + '</div><span>Paremtas klinikiniais sprendimų kriterijais</span></div>' +
          '<div class="ftcs-intro-list-item"><div class="ftcs-check">' + svgCheckSmall + '</div><span>Gausite aiškią rekomendaciją</span></div>' +
        '</div>' +
        '<button class="ftcs-btn ftcs-btn-primary ftcs-btn-large" id="ftcsStartBtn">Pradėti testą ' + svgArrowRight + '</button>' +
      '</div></div>' +

      // Q1 — Duration
      '<div class="ftcs-slide" id="ftcsQ1">' +
        '<div class="ftcs-question-num">1 klausimas iš 5</div>' +
        '<div class="ftcs-question-text">Kiek laiko jaučiate skausmą?</div>' +
        '<div class="ftcs-question-hint">Skausmo trukmė yra svarbus faktorius vertinant gydymo galimybes.</div>' +
        '<div class="ftcs-options" id="ftcsO1">' +
          '<div class="ftcs-option" data-val="10"><div class="ftcs-option-radio"></div><div class="ftcs-option-text">Mažiau nei 6 savaites</div></div>' +
          '<div class="ftcs-option" data-val="35"><div class="ftcs-option-radio"></div><div class="ftcs-option-text">6\u201312 savaičių</div></div>' +
          '<div class="ftcs-option" data-val="60"><div class="ftcs-option-radio"></div><div class="ftcs-option-text">3\u20136 mėnesius</div></div>' +
          '<div class="ftcs-option" data-val="85"><div class="ftcs-option-radio"></div><div class="ftcs-option-text">Daugiau nei 6 mėnesius</div></div>' +
        '</div>' +
      '</div>' +

      // Q2 — Severity slider
      '<div class="ftcs-slide" id="ftcsQ2">' +
        '<div class="ftcs-question-num">2 klausimas iš 5</div>' +
        '<div class="ftcs-question-text">Koks yra kasdienio skausmo stiprumas?</div>' +
        '<div class="ftcs-question-hint">Įvertinkite vidutinį skausmo lygį per pastarąją savaitę.</div>' +
        '<div class="ftcs-slider-wrap"><div class="ftcs-slider-labels"><span class="ftcs-slider-label left">Silpnas, pakenčiamas</span><span class="ftcs-slider-label right">Stiprus, nepakenčiamas</span></div>' +
        '<div class="ftcs-range-track"><input type="range" class="ftcs-range" id="ftcsR2" min="0" max="100" value="50"></div>' +
        '<div class="ftcs-range-value" id="ftcsV2"></div></div>' +
      '</div>' +

      // Q3 — Neurological symptoms
      '<div class="ftcs-slide" id="ftcsQ3">' +
        '<div class="ftcs-question-num">3 klausimas iš 5</div>' +
        '<div class="ftcs-question-text">Ar turite neurologinių simptomų?</div>' +
        '<div class="ftcs-question-hint">Tirpimas, silpnumas ar šlapimo sutrikimai gali rodyti rimtesnę problemą.</div>' +
        '<div class="ftcs-options" id="ftcsO3">' +
          '<div class="ftcs-option" data-val="5"><div class="ftcs-option-radio"></div><div class="ftcs-option-text">Jokių neurologinių simptomų</div></div>' +
          '<div class="ftcs-option" data-val="30"><div class="ftcs-option-radio"></div><div class="ftcs-option-text">Retkarčiais tirpimas ar dilgčiojimas</div></div>' +
          '<div class="ftcs-option" data-val="65"><div class="ftcs-option-radio"></div><div class="ftcs-option-text">Nuolatinis tirpimas arba raumenų silpnumas</div></div>' +
          '<div class="ftcs-option" data-val="95"><div class="ftcs-option-radio"></div><div class="ftcs-option-text">Šlapimo/tuštinimosi sutrikimai ar progresuojantis silpnumas</div></div>' +
        '</div>' +
      '</div>' +

      // Q4 — Previous treatments
      '<div class="ftcs-slide" id="ftcsQ4">' +
        '<div class="ftcs-question-num">4 klausimas iš 5</div>' +
        '<div class="ftcs-question-text">Kokius gydymo būdus jau bandėte?</div>' +
        '<div class="ftcs-question-hint">Konservatyvaus gydymo patirtis padeda nustatyti tolimesnius žingsnius.</div>' +
        '<div class="ftcs-options" id="ftcsO4">' +
          '<div class="ftcs-option" data-val="10"><div class="ftcs-option-radio"></div><div class="ftcs-option-text">Dar nieko nebandžiau</div></div>' +
          '<div class="ftcs-option" data-val="30"><div class="ftcs-option-radio"></div><div class="ftcs-option-text">Vaistai ir/ar mankšta — šiek tiek padėjo</div></div>' +
          '<div class="ftcs-option" data-val="60"><div class="ftcs-option-radio"></div><div class="ftcs-option-text">Kineziterapija + vaistai — ribota nauda</div></div>' +
          '<div class="ftcs-option" data-val="90"><div class="ftcs-option-radio"></div><div class="ftcs-option-text">Išbandžiau viską (terapija, injekcijos, vaistai) — be pagerėjimo</div></div>' +
        '</div>' +
      '</div>' +

      // Q5 — Daily life impact slider
      '<div class="ftcs-slide" id="ftcsQ5">' +
        '<div class="ftcs-question-num">5 klausimas iš 5</div>' +
        '<div class="ftcs-question-text">Kaip skausmas veikia kasdienį gyvenimą?</div>' +
        '<div class="ftcs-question-hint">Ar galite dirbti, sportuoti, miegoti be skausmo?</div>' +
        '<div class="ftcs-slider-wrap"><div class="ftcs-slider-labels"><span class="ftcs-slider-label left">Minimaliai trukdo</span><span class="ftcs-slider-label right">Visiškai riboja</span></div>' +
        '<div class="ftcs-range-track"><input type="range" class="ftcs-range" id="ftcsR5" min="0" max="100" value="50"></div>' +
        '<div class="ftcs-range-value" id="ftcsV5"></div></div>' +
      '</div>' +

      // Email gate
      '<div class="ftcs-slide" id="ftcsEmail"><div class="ftcs-email-gate">' +
        '<div class="ftcs-email-icon">' + svgMail + '</div>' +
        '<h3>Jūsų rezultatai paruošti!</h3>' +
        '<p>Įveskite savo el. paštą ir gaukite detalią analizę bei asmenines rekomendacijas tiesiai į pašto dėžutę.</p>' +
        '<div class="ftcs-input-wrap"><input type="email" class="ftcs-input" id="ftcsEmailInput" placeholder="jūsų@elpaštas.lt"><div class="ftcs-email-error" id="ftcsEmailError">Įveskite teisingą el. pašto adresą</div></div>' +
        '<button class="ftcs-btn ftcs-btn-primary ftcs-btn-large" id="ftcsEmailBtn">Gauti rezultatus ' + svgCheck + '</button>' +
        '<div class="ftcs-email-note">Galėsite bet kada atsisakyti naujienlaiškio.</div>' +
      '</div></div>' +

      // Results
      '<div class="ftcs-slide" id="ftcsResults"><div class="ftcs-results">' +
        '<div class="ftcs-result-circle-wrap"><div class="ftcs-result-circle" id="ftcsResultCircle"><div class="ftcs-result-type" id="ftcsResultType"></div><div class="ftcs-result-label" id="ftcsResultLabel"></div></div></div>' +
        '<div class="ftcs-result-text" id="ftcsResultText"></div>' +
        '<div class="ftcs-result-detail" id="ftcsResultDetail"><h4 id="ftcsDetailTitle"></h4><p id="ftcsDetailText"></p></div>' +
        '<a class="ftcs-result-cta" href="' + BOOKING_URL + '" target="_blank" id="ftcsBookingBtn">Registruotis konsultacijai ' + svgCalendar + '</a>' +
        '<div class="ftcs-disclaimer">Šis klausimynas yra informacinio pobūdžio ir nepakeičia profesionalaus gydytojo ar neurochirurgo konsultacijos. Visada kreipkitės į specialistą dėl tikslios diagnozės.</div>' +
      '</div></div>' +

      // Nav buttons
      '<div class="ftcs-buttons" id="ftcsNav" style="display:none;">' +
        '<button class="ftcs-btn ftcs-btn-secondary" id="ftcsBtnBack">' + svgArrowLeft + ' Atgal</button>' +
        '<button class="ftcs-btn ftcs-btn-primary" id="ftcsBtnNext">Kitas ' + svgArrowRight + '</button>' +
      '</div>' +

    '</div>';

  // ── Mount ──
  var target = document.getElementById('ftc-surgery-checker');
  if (!target) return;
  var root = document.createElement('div');
  root.className = 'ftcs';
  root.id = 'ftcsChecker';
  root.innerHTML = html;
  target.appendChild(root);

  // ── State ──
  var currentStep = 0;
  var answers = { 1: null, 2: 50, 3: null, 4: null, 5: 50 };
  var totalSteps = 5;
  var optionQs = [1, 3, 4];
  var sliderQs = [2, 5];

  // ── DOM refs ──
  var nav          = document.getElementById('ftcsNav');
  var progressWrap = document.getElementById('ftcsProgressWrap');
  var backBtn      = document.getElementById('ftcsBtnBack');
  var nextBtn      = document.getElementById('ftcsBtnNext');
  var progressFill = document.getElementById('ftcsProgressFill');
  var stepCount    = document.getElementById('ftcsStepCount');

  // ── Event listeners ──
  document.getElementById('ftcsStartBtn').addEventListener('click', function () {
    currentStep = 1; showStep();
  });
  nextBtn.addEventListener('click', function () {
    // Only used for slider steps (Q2, Q5)
    currentStep = currentStep < totalSteps ? currentStep + 1 : 6;
    showStep();
  });
  backBtn.addEventListener('click', function () {
    currentStep = currentStep === 6 ? totalSteps : Math.max(1, currentStep - 1);
    showStep();
  });
  document.getElementById('ftcsEmailBtn').addEventListener('click', submitEmail);

  // Sliders
  sliderQs.forEach(function (q) {
    document.getElementById('ftcsR' + q).addEventListener('input', function () { updateVal(q); });
  });

  // Option cards (auto-advance)
  optionQs.forEach(function (q) {
    document.querySelectorAll('#ftcsO' + q + ' .ftcs-option').forEach(function (el) {
      el.addEventListener('click', function () {
        answers[q] = parseInt(el.getAttribute('data-val'));
        el.parentElement.querySelectorAll('.ftcs-option').forEach(function (s) { s.classList.remove('selected'); });
        el.classList.add('selected');
        // Auto-advance after brief visual feedback
        setTimeout(function () {
          currentStep = q < totalSteps ? q + 1 : 6;
          showStep();
        }, 350);
      });
    });
  });

  // ── Functions ──
  function updateVal(q) {
    var slider = document.getElementById('ftcsR' + q);
    answers[q] = parseInt(slider.value);
    var valEl = document.getElementById('ftcsV' + q);
    var val = answers[q];
    if (val < 25) valEl.textContent = 'Žemas lygis';
    else if (val < 50) valEl.textContent = 'Vidutiniškai žemas';
    else if (val === 50) valEl.textContent = 'Vidutinis';
    else if (val < 75) valEl.textContent = 'Vidutiniškai aukštas';
    else valEl.textContent = 'Aukštas lygis';
  }

  function calcScore() {
    var sum = 0;
    for (var i = 1; i <= 5; i++) { sum += (answers[i] === null ? 50 : answers[i]); }
    return Math.round(sum / 5);
  }

  function submitEmail() {
    var emailInput = document.getElementById('ftcsEmailInput');
    var email = emailInput.value.trim();
    var errorEl = document.getElementById('ftcsEmailError');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.style.display = 'block';
      emailInput.style.borderColor = '#e05555';
      return;
    }
    errorEl.style.display = 'none';
    emailInput.style.borderColor = '#00BEC3';
    sendToKlaviyo(email);
    currentStep = 7;
    showStep();
    computeResults();
  }

  function sendToKlaviyo(email) {
    if (!KLAVIYO_COMPANY_ID || !KLAVIYO_LIST_ID) {
      console.warn('[FTC Surgery] Klaviyo not configured.');
      return;
    }
    var score = calcScore();
    var resultType = score > 60 ? 'urgent' : (score < 35 ? 'conservative' : 'specialist');

    var subData = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Surgery Decision Widget',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email },
              subscriptions: {
                email: {
                  marketing: { consent: 'SUBSCRIBED' }
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(subData)
    }).then(function (r) {
      console.log('[FTC Surgery] Klaviyo subscribe:', r.status);
      if (!r.ok) return r.text().then(function (b) { console.error('[FTC Surgery] Subscribe error:', b); });
    }).catch(function (e) {
      console.error('[FTC Surgery] Subscribe fetch error:', e);
    });
var subData2={data:{type:'subscription',attributes:{custom_source:'Surgery Check Widget',profile:{data:{type:'profile',attributes:{email:email},subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}},relationships:{list:{data:{type:'list',id:'VfJCJm'}}}}}};
fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO_COMPANY_ID,{method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},body:JSON.stringify(subData2)});
resultType = {urgent:'Skubi konsultacija',conservative:'Konservatyvus gydymas',specialist:'Specialisto konsultacija'}[resultType] || resultType;
var profileData = {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          properties: {
            surgery_decision_score: score,
            surgery_decision_result: resultType,
            surgery_decision_date: new Date().toISOString()
          }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(profileData)
    }).then(function (r) {
      console.log('[FTC Surgery] Klaviyo profile:', r.status);
      if (!r.ok) return r.text().then(function (b) { console.error('[FTC Surgery] Profile error:', b); });
    }).catch(function (e) {
      console.error('[FTC Surgery] Profile fetch error:', e);
    });
  }

  function computeResults() {
    var score = calcScore();
    var circle = document.getElementById('ftcsResultCircle');
    var typeEl = document.getElementById('ftcsResultType');
    var labelEl = document.getElementById('ftcsResultLabel');
    var textEl = document.getElementById('ftcsResultText');
    var dTitle = document.getElementById('ftcsDetailTitle');
    var dText = document.getElementById('ftcsDetailText');
    circle.className = 'ftcs-result-circle';

    if (score < 35) {
      circle.classList.add('conservative');
      typeEl.textContent = 'Rekomendacija';
      labelEl.textContent = 'Konservatyvus gydymas';
      textEl.textContent = 'Jūsų atsakymai rodo, kad stuburo problema gali būti sėkmingai gydoma be operacijos. Konservatyvus gydymas — kineziterapija, pratimai ir gyvenimo būdo korekcija — dažniausiai duoda puikius rezultatus.';
      dTitle.textContent = 'Ką rekomenduojame?';
      dText.textContent = 'Pradėkite nuo profesionalaus funkcinio įvertinimo. Kineziterapeutas parengs individualią programą, kuri padės sustiprinti giluminius raumenis, sumažinti spaudimą diskams ir pagerinti judrumą. 80% stuburo išvaržų išgyja konservatyviai per 6\u201312 savaičių.';
    } else if (score <= 60) {
      circle.classList.add('specialist');
      typeEl.textContent = 'Rekomendacija';
      labelEl.textContent = 'Kreipkitės į specialistą';
      textEl.textContent = 'Jūsų simptomai rodo, kad reikia profesionalaus įvertinimo. Specialistas padės nustatyti tikslią diagnozę ir parinks optimaliausią gydymo planą — dažnai dar galimą be operacijos.';
      dTitle.textContent = 'Kodėl verta nedelsti?';
      dText.textContent = 'Kuo anksčiau kreipsitės, tuo daugiau gydymo galimybių turėsite. Mūsų kineziterapeutai atliks išsamų funkcinį įvertinimą, o prireikus — nukreips pas neurochirurgą ar ortopedą. Daugeliui pacientų intensyvi kineziterapija padeda išvengti operacijos.';
    } else {
      circle.classList.add('urgent');
      typeEl.textContent = 'Rekomendacija';
      labelEl.textContent = 'Skubus įvertinimas';
      textEl.textContent = 'Jūsų simptomai rodo, kad reikalingas skubus specialisto įvertinimas. Tai nereiškia, kad operacija neišvengiama, tačiau svarbu neatidėlioti vizito.';
      dTitle.textContent = 'Svarbu žinoti';
      dText.textContent = 'Progresuojantis silpnumas, šlapimo sutrikimai ar ilgalaikis stiprus skausmas reikalauja skubios diagnostikos. Net ir šiais atvejais operacija nėra vienintelė išeitis — tačiau tikslus įvertinimas būtinas kuo greičiau. Mūsų komanda padės jums greitai patekti pas reikiamą specialistą.';
    }
  }

  function showStep() {
    var slides = document.querySelectorAll('#ftcsChecker .ftcs-slide');
    slides.forEach(function (s) { s.classList.remove('active'); });

    if (currentStep === 0) {
      document.getElementById('ftcsIntro').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    } else if (currentStep >= 1 && currentStep <= totalSteps) {
      document.getElementById('ftcsQ' + currentStep).classList.add('active');
      progressWrap.style.display = 'block';
      progressFill.style.width = Math.round((currentStep / totalSteps) * 100) + '%';
      stepCount.textContent = currentStep + ' iš ' + totalSteps + ' klausimų';
      // Option steps: auto-advance, hide Next; Slider steps: show Next
      if (sliderQs.indexOf(currentStep) !== -1) {
        nav.style.display = 'flex';
        nextBtn.style.display = '';
        backBtn.style.visibility = 'visible';
        nextBtn.innerHTML = currentStep === totalSteps
          ? 'Gauti rezultatus ' + svgCheck
          : 'Kitas ' + svgArrowRight;
        updateVal(currentStep);
      } else {
        nav.style.display = currentStep === 1 ? 'none' : 'flex';
        nextBtn.style.display = 'none';
        backBtn.style.visibility = 'visible';
      }
    } else if (currentStep === 6) {
      document.getElementById('ftcsEmail').classList.add('active');
      nav.style.display = 'flex'; progressWrap.style.display = 'block';
      progressFill.style.width = '100%';
      stepCount.textContent = 'Paskutinis žingsnis';
      backBtn.style.visibility = 'visible';
      nextBtn.style.display = 'none';
    } else if (currentStep === 7) {
      document.getElementById('ftcsResults').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    }
  }

})();